import React from "react";
import PropTypes from "prop-types";
import Icon from './Icon';

/**
  This component will display a Bootstrap-like Pill component with a text and one custom action inside.
*/
const Pill = ({ text, icon, title, onAction }) => (
  <div className="pill">
    {text}
    {onAction && (
      <a onClick={onAction} title={title}>
        {icon && <Icon iconType={icon} />}
      </a>
    )}
  </div>
);

Pill.propTypes = {
  /** This text will be displayed inside the Pill */
  text: PropTypes.string.isRequired,
  /** This action will be called when user click on icon */
  onAction: PropTypes.func,
  /** Icon to be displayed for the action */
  icon: PropTypes.string,
  /** Title to be displayed when hovering the icon */
  title: PropTypes.string
};

export default Pill;
